// extracted by mini-css-extract-plugin
export var cartContainer = "_oj-4";
export var gray = "_oj-1";
export var itemContainer = "_oj-2";
export var itemDetails = "_oj-3";
export var strong = "_oj-0";